package com.example.mystybag.sharedmodels.project.requestModels.merchant

import com.example.mystybag.sharedmodels.AllCommands.STAFF_CHANGE_PASSWORD
import com.example.mystybag.sharedmodels.base.BaseRequestModel
import kotlinx.serialization.Serializable

@Serializable
data class ChangePasswordStaffRequestModel(
    val newPassword: String
) : BaseRequestModel(api = STAFF_CHANGE_PASSWORD)
